interface LetterProps {
  transform: string;
  letter: string;
  fillTextStyle?: React.CSSProperties;
}

const fillTextStyle = {
  fontVariant: 'normal',
  fontWeight: 1000,
  fontStretch: 'normal',
  fontSize: '9px',
  fontFamily: 'Arial',
  // writingMode: "lr-tb",
  fill: '#231f20',
  fillOpacity: 1,
  // fillRule: 'nonzero',
  stroke: 'none',
};

export default function Letter(props: LetterProps) {
  return (
    <text
      xmlSpace="preserve"
      transform={props.transform}
      style={
        {
          //  InkscapeFontSpecification: "ArialMT"
        }
      }
      fontVariant="normal"
      fontWeight={400}
      fontStretch="normal"
      fontSize="7px"
      fontFamily="Arial"
      writingMode="lr-tb"
      fill="#231f20"
      fillOpacity={1}
      fillRule="nonzero"
      stroke="none"
    >
      <tspan x={0} y={0} style={fillTextStyle}>
        {props.letter}
      </tspan>
    </text>
  );
}
